'use client';
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export const BlogSkeleton = () => {
    return (
        <section className="blog-section my-5">
            <div className="container">
                <div className="row justify-content-center g-4">
                    <div className="col-lg-4 col-sm-6">
                        <Skeleton height={530} borderRadius={20} />
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <Skeleton height={530} borderRadius={20} />
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <Skeleton height={530} borderRadius={20} />
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <Skeleton height={530} borderRadius={20} />
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <Skeleton height={530} borderRadius={20} />
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <Skeleton height={530} borderRadius={20} />
                    </div>
                </div>
            </div>
        </section>
    );
}